import { SHIPPING_MODEL_KEY } from 'models/daos/shipping/constants'

const SHIPPING_BEFORE_CREATE_HOOK = {
  [SHIPPING_MODEL_KEY.CODE]: str => str.replace(/\./g, '-')
}

export {
  SHIPPING_BEFORE_CREATE_HOOK
}
